import React from 'react';
import { swishHorizontalLogoImage } from '../../../../assets';
import './styles.scss';

const SwishLogoBanner = () => (
  <div className="swish-logo-banner">
    <img src={swishHorizontalLogoImage} alt="Swish" />
  </div>
);

export default SwishLogoBanner;
